// extracted by mini-css-extract-plugin
module.exports = {"label":"style_label__2xhV9","value":"style_value__1Kzm_"};